import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src3099364000/src/treeunfe-website-nextjs/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/codebuild/output/src3099364000/src/treeunfe-website-nextjs/src/components/organisms/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroHeader"] */ "/codebuild/output/src3099364000/src/treeunfe-website-nextjs/src/components/organisms/header/index.tsx");
